// removed by extract-text-webpack-plugin
module.exports = {"button":"button__1wKCV","button_wide":"button_wide__17SsF","active":"active__2HHpc"};


//////////////////
// WEBPACK FOOTER
// ./components/button/style.scss
// module id = appZ
// module chunks = 13